/**
 * @generated SignedSource<<4e8f8249787338d84a996ca6514463da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type digitalArchiveLinkUpdatedDateUrlPath$data = {
  readonly item: {
    readonly updatedDate?: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "digitalArchiveLinkUpdatedDateUrlPath";
};
export type digitalArchiveLinkUpdatedDateUrlPath$key = {
  readonly " $data"?: digitalArchiveLinkUpdatedDateUrlPath$data;
  readonly " $fragmentSpreads": FragmentRefs<"digitalArchiveLinkUpdatedDateUrlPath">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "digitalArchiveLinkUpdatedDateUrlPath",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedDate",
              "storageKey": null
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UrlPath",
  "abstractKey": null
};

(node as any).hash = "1daae675254d73f0f9ca59fee2be39b4";

export default node;
